<template>
  <div class="certificate-result">
    <van-nav-bar title="证书预览" left-arrow @click-left="$router.back()" />
    <van-skeleton
      :row="5"
      :loading="loading"
      :avatar-shape="'square'"
      style="margin-top: 40px"
    >
      <van-empty v-if="!certificate?.cert" description="暂无证书信息" />
      <div
        ref="certificateCanvas"
        class="certificate-container"
        @click="showImage = true"
        v-else
      >
        <!-- 证书背景 -->
        <!-- <img :src="certificateTemplate" class="certificate-bg" /> -->
        <img :src="certificateSrc" class="certificate-bg" />

        <!-- 渲染的文本信息 -->
        <!-- <div class="certificate-content">
        <p class="certificate-title">{{ certificate.name }}</p>
        <p class="certificate-info">证书编号：{{ certificate.certificate }}</p>
        <template v-if="certificate.major">
          <p class="certificate-info">培训专业：{{ certificate.major }}</p>
        </template>
        <template v-if="certificate.occupation">
          <p class="certificate-info">职业名称：{{ certificate.occupation }}</p>
        </template>
        <template v-if="certificate.direction">
          <p class="certificate-info">职业方向：{{ certificate.direction }}</p>
        </template>
        <p class="certificate-info">证书级别：{{ certificate.level }}</p>
        <p class="certificate-info">发证时间：{{ certificate.issuancetime }}</p>
      </div> -->
      </div>
    </van-skeleton>
    <van-image-preview
      v-if="certificate?.cert"
      :images="[certificateSrc]"
      :show-index="false"
      v-model="showImage"
      closeable
    ></van-image-preview>

    <!-- 下载按钮 -->
    <!-- <div class="buttons">
      <van-button type="primary" block @click="downloadImage"
        >下载图片</van-button
      >
      <van-button type="info" block @click="downloadPDF">下载 PDF</van-button>
    </div> -->
  </div>
</template>
  
  <script>
import api from "@/api";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import simhei from "@/assets/fonts/simhei-normal.js";
import { getStorage } from "@/utils/config";

export default {
  name: "CertificatePreview",
  computed: {
    // 获取证书背景图片路径
    certificateSrc() {
      return this.certificate?.cert
        ? this.certificate?.cert.startsWith("http")
          ? this.certificate?.cert
          : getStorage() + this.certificate?.cert
        : "";
    },
  },
  data() {
    return {
      certificate: null,
      showImage: false, // 控制图片预览
      certificateTemplate: "",
      loading: true, // 控制加载状态
      // certificateTemplate: require("@/assets/images/2.jpg"), // 证书背景图片
    };
  },
  mounted() {
    console.log("preview query", this.$route.query);
    this.certificateTemplate =
      this.$route.query.type === "1"
        ? require("@/assets/images/1.jpg")
        : require("@/assets/images/2.jpg");
    this.fetchCertificates();
  },
  methods: {
    // 查询证书信息
    async fetchCertificates() {
      const { type, name, idnumber, phone } = this.$route.query;
      try {
        const params = { type, name, idcard: idnumber, phone };
        console.log("params", params);
        const res = await api.postCert(params);
        console.log("res", res);
        if (res.data.data && res.data.success) {
          console.log("certificate data", res.data.data);
          this.certificate = res.data.data;
        } else {
          this.$toast.fail("未找到相关证书");
        }
      } catch (err) {
        console.log("error", err);
        this.$toast.fail("查询失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    // 下载合成的证书图片
    async downloadImage() {
      const canvas = await html2canvas(this.$refs.certificateCanvas, {
        width: 800, // 固定宽度
        height: 550, // 固定高度
        scale: 1, // 提高清晰度
        useCORS: true,
      });
      const image = canvas.toDataURL("image/png");

      // 创建下载链接
      const link = document.createElement("a");
      link.href = image;
      link.download = `证书_${this.certificate.certificate}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // 下载合成的 PDF
    // async downloadPDF() {
    //   const canvas = await html2canvas(this.$refs.certificateCanvas);
    //   const image = canvas.toDataURL("image/png");

    //   const pdf = new jsPDF("landscape", "mm", "a4");
    //   const width = pdf.internal.pageSize.getWidth();
    //   const height = pdf.internal.pageSize.getHeight();

    //   pdf.addImage(image, "PNG", 0, 0, width, height);
    //   pdf.save(`证书_${this.certificate.certificate}.pdf`);
    // },
    async downloadPDF() {
      const pdf = new jsPDF({
        orientation: "landscape", // 横向
        unit: "mm",
        format: "a4",
      });

      // 注册中文字体
      pdf.addFileToVFS("simhei.ttf", simhei);
      pdf.addFont("simhei.ttf", "simhei", "normal");
      pdf.setFont("simhei");

      // 获取 PDF 页面大小
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // 加载背景图片
      const img = new Image();
      img.src = this.certificateTemplate;
      img.crossOrigin = "anonymous"; // 允许跨域加载

      img.onload = () => {
        pdf.addImage(img, "JPEG", 0, 0, pageWidth, pageHeight);

        // 设置文本样式
        pdf.setFontSize(24);

        // 计算居中位置
        const textX = pageWidth / 2;
        const nameY = pageHeight * 0.4;
        const infoY = pageHeight * 0.5;

        // 绘制证书信息
        pdf.setTextColor(51);
        pdf.text(this.certificate.name, textX, nameY, { align: "center" });
        pdf.setFontSize(18);
        pdf.setTextColor(102);
        pdf.text(`证书编号：${this.certificate.certificate}`, textX, infoY, {
          align: "center",
        });
        pdf.text(`培训专业：${this.certificate.major}`, textX, infoY + 10, {
          align: "center",
        });
        pdf.text(`证书级别：${this.certificate.level}`, textX, infoY + 20, {
          align: "center",
        });
        pdf.text(
          `发证时间：${this.certificate.issuancetime}`,
          textX,
          infoY + 30,
          { align: "center" }
        );

        // 下载 PDF
        pdf.save(`证书_${this.certificate.certificate}.pdf`);
      };
    },
  },
};
</script>
  
  <style scoped>
.certificate-result {
  padding: 20px;
  margin-bottom: 20px;
  /* min-width: 800px; */
}
.certificate-container {
  position: relative;
  /* width: 800px; */
  /* height: 550px; */
  margin: 0 auto;
  text-align: center;
  margin-top: 15px;
}

.certificate-bg {
  width: 100%;
  height: auto;
}

.certificate-content {
  position: absolute;
  top: 30%;
  left: 0;
  right: 0;
  text-align: center;
  color: #000;
  font-size: 20px;
  /* font-weight: bold; */
}

.certificate-title {
  font-size: 28px;
  margin-bottom: 16px;
  color: #333;
}

.certificate-info {
  font-size: 18px;
  margin: 10px 0;
  color: #666;
}

.buttons {
  margin-top: 20px;
}
.van-button {
  margin-bottom: 10px;
}
</style>
  